import { motion } from "framer-motion";

export default function ResultsHero({ eyebrow, primary }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="py-24 md:py-32 text-center"
    >
      <div className="stage">
        <div className="section-label mb-6">{eyebrow}</div>
        <div className="font-serif italic text-2xl md:text-3xl text-[#737373] mb-6">
          Primary Observation — {primary.name}
        </div>
        <h1
          className="font-serif font-light text-4xl sm:text-5xl md:text-6xl lg:text-[80px] leading-[1.02] display-tight"
          data-testid="results-headline"
        >
          {primary.short}
        </h1>
      </div>
    </motion.div>
  );
}
